// extracted by mini-css-extract-plugin
module.exports = {"search-form":"L_ff flex-grow-1 form-group mb-0"};